import { CertificateType } from 'src/app/registration/shared/models/certificate-type.model';

export class Education {
    id: string;
    highestGradeCompleted: string;
    lastSchoolAttended: string;
    certification: string;
    specialCourses: string;
}
